// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3tltb","log":"ModalInventoryLogs_log__113O0","date":"ModalInventoryLogs_date__9LdIN","userName":"ModalInventoryLogs_userName__RK7Ou"};